const STORAGE_KEY = 'fpVisitorId';

const readFromResult = (result) =>
  result?.visitor_id || result?.visitorId || null;

const readFromStorage = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || null;
  } catch (e) {
    return null;
  }
};

const saveToStorage = (visitorId) => {
  if (!visitorId) return;

  try {
    sessionStorage.setItem(STORAGE_KEY, visitorId);
  } catch (e) {}
};

export const getVisitorId = async (timeoutMs = 4000) => {
  if (typeof window === 'undefined') return null;

  if (!window.fpVisitorIdPromise) return null;

  const known = readFromResult(window.fpResult) || readFromStorage();
  if (known) {
    saveToStorage(known);
    return known;
  }

  try {
    const timeout = new Promise((resolve) =>
      setTimeout(() => resolve(null), timeoutMs)
    );
    const visitorId = await Promise.race([window.fpVisitorIdPromise, timeout]);

    saveToStorage(visitorId);

    return visitorId || null;
  } catch (e) {
    return null;
  }
};

export const VISITOR_LIMIT_STATUS = 'VISITOR_LIMIT_EXCEEDED';

const LIMIT_PATTERN = /LIMIT|EXCEED|TOO[_ -]?MANY|VISITOR/i;

const matchesLimit = (value) =>
  typeof value === 'string' && LIMIT_PATTERN.test(value);

export const isVisitorLimitError = (error) => {
  const response = error?.response;
  if (!response) return false;

  const { status, data } = response;
  if (status === 429) return true;
  if (status < 400 || status >= 500 || !data) return false;

  return [
    data.code,
    data.errorCode,
    data.error,
    data.status,
    data.message
  ].some(matchesLimit);
};
